module.exports = __webpack_public_path__ + "img/sandalias.f0a33298.jpg";